import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { replacePlaceholder } from '@/helpers/cms';
import { groupMembeRakeback } from '@/helpers/user';
import { formatWalletValue } from '@/helpers/wallet';
import { useCommonStore } from '@/store';

const RAKEBACK_SUM = 'rakeback_sum';

export const useFormatRakebackAmount = (text: string | null) => {
  const { user, rakebacks, currencies } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
      rakebacks: state.rakebacks,
      currencies: state.currencies,
    }))
  );

  const userCurrencyRakeback = useMemo(() => {
    if (!user || !rakebacks) return;
    const { currency } = user;

    return rakebacks.find((item) => item.currency === currency);
  }, [rakebacks, user]);

  const formattedRakebackAmount = useMemo(() => {
    if (!user) return '';

    const userWithRakeback = groupMembeRakeback(user);

    if (!userWithRakeback) return '';

    const { currency } = user;

    return String(
      formatWalletValue(
        currency,
        Number(userCurrencyRakeback?.amountCentsDecimal) || 0,
        currencies,
        true
      )
    );
  }, [currencies, user, userCurrencyRakeback]);

  if (!text) return '';

  return replacePlaceholder(text, RAKEBACK_SUM, formattedRakebackAmount);
};
